import { render, staticRenderFns } from "./game-start.vue?vue&type=template&id=20473d30&scoped=true&"
import script from "./game-start.vue?vue&type=script&lang=js&"
export * from "./game-start.vue?vue&type=script&lang=js&"
import style0 from "./game-start.vue?vue&type=style&index=0&id=20473d30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20473d30",
  null
  
)

export default component.exports